export default __webpack_public_path__ + "dfeda957358918e316883227794da24a.png";